<template>
  <div class="mk-subject-client">
    <div class="mk-subject-title">{{ element.titleBarName }}</div>
    <div class="mk-subject-summary">{{ element.titleBarDesc }}</div>
    <div class="mk-subject-client-list">
      <div
        class="mk-subject-client-li"
        v-for="(item, index) in childItem.propsValue.data.slice(0, 4)"
        :key="index"
      >
        <div class="mk-subject-client-top">
          <div class="mk-subject-client-title" v-if="item.customField1">{{ item.customField1 }}</div>
          <div
            class="mk-subject-client-href"
            v-if="item.customField2.text"
          >{{ item.customField2.text }}</div>
        </div>
        <div class="mk-subject-client-bottom">
          <div
            class="mk-subject-client-img"
            v-for="(childItem, childIndex) in item.customField3"
            :key="childIndex"
          >
            <img :src="childItem.customField31" alt />
          </div>
        </div>
      </div>
      <div class="mk-subject-client-caozuo more">查看更多</div>
      <div class="mk-subject-client-caozuo close">收起</div>
    </div>
  </div>
</template>

<script>
import { buttonObject } from "@/modules/autoweb/config/elementObject.js";
let buttonObjectTemp = _.cloneDeep(buttonObject);
buttonObjectTemp.text = "查看更多 →";
export default {
  name: "MkImageIconPhone",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    className() {
      let selectClass = _.filter(this.element.class, item => item.selected)[0];
      return selectClass.value;
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text"
        },
        {
          code: "customField2",
          label: "按钮",
          type: "button"
        },
        {
          code: "customField3",
          label: "logo墙",
          type: "list",
          children: [
            {
              code: "customField31",
              label: "logo",
              type: "image",
              width: 80,
              height: 30
            }
          ]
        }
      ],
      data: [
        {
          customField1: "组标题名称",
          customField2: _.cloneDeep(buttonObjectTemp),
          customField3: []
        },
        {
          customField1: "组标题名称",
          customField2: _.cloneDeep(buttonObjectTemp),
          customField3: []
        },
        {
          customField1: "组标题名称",
          customField2: _.cloneDeep(buttonObjectTemp),
          customField3: []
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.mk-subject-client {
  padding: 0.56rem 0.69rem 0.28rem;
  background-color: #fff;
  text-align: center;
  .mk-subject-title {
    font-family: AlibabaPuHuiTi_3_85_Bold;
    font-size: 0.33rem;
    color: #e60012;
    line-height: 0.39rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.15rem;
  }
  .mk-subject-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.42rem;
    text-align: center;
    margin-bottom: 0.44rem;
  }
  .mk-subject-client-li {
    height: auto;
    background-color: #ccc;
    border-radius: 0.14rem;
    padding: 0.42rem 0.21rem 0.3rem;
    margin-bottom: 0.3rem;
  }
  .mk-subject-client-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.3rem;
    .mk-subject-client-title {
      font-family: AlibabaPuHuiTi_3_65_Medium;
      font-size: 0.26rem;
      color: #515051;
      line-height: 0.42rem;
      text-align: left;
    }
    .mk-subject-client-href {
      font-family: AlibabaPuHuiTi_3_55_Regular;
      font-size: 0.22rem;
      color: #717071;
      line-height: 0.42rem;
      text-align: left;
    }
  }
  .mk-subject-client-bottom {
    display: flex;
    justify-content: flex-start;
    /* 换行 */
    flex-wrap: wrap;
    gap: 0.1rem;
    .mk-subject-client-img {
      width: 1.3rem;
      height: 0.46rem;
      flex-shrink: 0;
      background: #ffffff;
      border-radius: 0.07rem;
      border: 1px solid #e8ebee;
      overflow: hidden;
      img{
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  .mk-subject-client-caozuo {
    text-align: center;
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.25rem;
    color: #717071;
    line-height: 0.42rem;
    text-align: center;
  }
}
</style>